/** Orden de aparición en /noticias (PR2) */
export const NEWS_ARTICLE_SLUGS = [
  'javiland',
  'ayuno-intermitente',
  'descanso-recuperacion',
];

export function parseNewsSlugFromPath(pathname) {
  const path = (pathname || '').replace(/\/$/, '') || '/';
  if (path === '/noticias') return null;
  const m = path.match(/^\/noticias\/([a-z0-9-]+)$/i);
  return m ? m[1].toLowerCase() : null;
}

export function isValidNewsSlug(slug) {
  return NEWS_ARTICLE_SLUGS.includes(slug);
}
